let SentryLib = null;

try {
  // eslint-disable-next-line import/no-extraneous-dependencies
  SentryLib = require('@sentry/react');
} catch (_) {
  // @sentry/react not installed — monitoring disabled
}

export function initSentry() {
  if (!SentryLib) return;
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;
  SentryLib.init({
    dsn,
    environment: process.env.NODE_ENV || 'production',
    tracesSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

// Sentry.ErrorBoundary fallback: a plain passthrough when Sentry is unavailable
const NoopErrorBoundary = ({ children }) => children;

export const Sentry = SentryLib
  ? SentryLib
  : { ErrorBoundary: NoopErrorBoundary };
